import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopCourseComponent } from './top-course.component';
import { Routes, RouterModule } from '@angular/router';
import { TopCourseService } from './top-course.service';
import { CourseDemoComponent } from '../course-demo/course-demo.component';
import { TabViewModule } from 'primeng/primeng';
import { CarouselModule } from 'ngx-bootstrap/carousel';
@NgModule( {
  imports: [
    CommonModule, RouterModule, TabViewModule, CarouselModule.forRoot()
  ],
  declarations: [ TopCourseComponent, CourseDemoComponent ],
  exports: [ TopCourseComponent, CourseDemoComponent ],
  providers: [ TopCourseService ]
} )
export class TopCourseModule { }



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/top-course/top-course.module.ts